// Carpetas fijas del Sistema de Gestión de SST.
// Los documentos originales se organizan en estas carpetas y, al subir un
// documento a una de ellas, se replica con la misma carpeta en cada empresa.
export const CATEGORIES = [
  "0_Perfil sociodemográfico",
  "1_Asignación de una persona que diseñe el Sistema de Gestión de SST",
  "2_Afiliación al sistema de Seguridad social",
  "3_Programa de Capacitación",
  "4_Plan de trabajo anual",
  "5_Evaluaciones médicas ocupacionales",
  "6 Y 7_Identificación de peligros, evaluación y valoración de riesgos",
  "8_Autoevaluación anual SST",
  "Inspecciones",
];

const FOLDER_COLORS = [
  "#00C4AE", "#A78BFA", "#4ADE80", "#FB923C", "#F472B6",
  "#38BDF8", "#FACC15", "#F87171",
];

export function folderColor(name) {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return FOLDER_COLORS[Math.abs(h) % FOLDER_COLORS.length];
}
